var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subscription-overview-view"},[_c('SubscriptionOverview')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }